import { useTheme } from '../hooks/useTheme';

/**
 * Light/dark switch.
 *
 * A real button with an accessible name that states what it will do, not just what is
 * currently showing -- "Switch to dark mode" tells a screen-reader user the outcome of
 * activating it. The glyph is decorative and hidden from assistive technology.
 */
export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const next = theme === 'dark' ? 'light' : 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      data-testid="theme-toggle"
      data-theme-state={theme}
      aria-label={`Switch to ${next} mode`}
      title={`Switch to ${next} mode`}
      className="flex h-9 w-9 items-center justify-center rounded-full text-base"
      style={{ color: 'var(--mm-text-muted)', border: '1px solid var(--mm-border)' }}
    >
      <span aria-hidden="true">{theme === 'dark' ? '☀' : '☾'}</span>
    </button>
  );
}
